import Container from "@/components/Container";
import alpha from "@/data/names";
import _ from "lodash";
import unslugify from "@/lib/unslugify";
import slugify from "@/lib/slugify";
import Link from "next/link";
import { NextSeo } from "next-seo";

export default function Category({ params, names }) {
  return (
    <Container noads={true}>
       <NextSeo noindex={true} nofollow={false}
        title={`Names Starting from ${unslugify(params.slug)}`}
        canonical={`https://cakeiy.com/names/${params.slug}`}
        description={`Direct Link to existing images for the names starting from ${params.slug} . You can edit name on the cake by clicking edit button on the next page.`}
        openGraph={{
          url: `https://cakeiy.com/names/${params.slug}`,
          title: `Names Starting from ${unslugify(params.slug)}`,
          description:`Direct Link to existing images for the names starting from ${params.slug} . You can edit name on the cake by clicking edit button on the next page.`
        }}
      />
      <div className="flex flex-col justify-center items-start max-w-2xl mx-auto mb-16 bg-white dark:bg-black pl-3">
        <h1 className="font-bold text-3xl md:text-5xl tracking-tight mb-4 text-black dark:text-white">
          Names Starting from {unslugify(params.slug)}
        </h1>
        <p className="text-black dark:text-white mb-16">
          Direct Link to existing images with the following names. You can edit
          name on the cake by clicking edit button on the next page.
          <Link
            href={`/names`}
            className="mx-2 dark:text-gray-100 font-bold py-1.5 rounded text-center text-gray-900 ">
            
              Back to Names
            
          </Link>
        </p>
        <div className="gap-2 grid grid-cols-1 sm:grid-cols-3 w-full">
          {names.map((item) => (
            (<Link
              key={item.name.toUpperCase()}
              href={`/cake-with-name/happy-birthday-${slugify(item.name)}-cake`}
              className="bg-blue-100 hover:bg-blue-300 dark:bg-gray-700 dark:text-gray-100 font-bold py-1.5 rounded text-center text-gray-900 border-green-200 border hover:border-green-300 ">

              {unslugify(item.name)}

            </Link>)
          ))}
        </div>
      </div>
    </Container>
  );
}

export async function getStaticPaths() {
  const alphabets = "abcdefghijklmnopqrstuvwxyz".split("");

  const paths = alphabets.map((p) => ({
    params: {
      slug: p,
    },
  }));
  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  //console.log(context.params)
  const names = _.filter(alpha, function (item) {
    return item.name
      .toUpperCase()
      .startsWith(context.params.slug.toUpperCase());
  });
  return { props: { params: context.params, names } };
}
